import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { publicAPI } from '../../services/api';
import './Marcas.css';

const Marcas = () => {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [heroStyle, setHeroStyle] = useState({ backgroundColor: 'rgb(116, 70, 49)', color: 'white' });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [brandsRes, heroImageRes] = await Promise.all([
          publicAPI.getBrands(),
          publicAPI.getHeroImage() // Obtener la imagen de título activa
        ]);
        setBrands(brandsRes.data);

        if (heroImageRes.data) {
          const { file_path, type } = heroImageRes.data;
          if (type === 'image') {
             setHeroStyle({ background: `url(${file_path}) center/cover no-repeat`, color: 'rgb(116, 70, 49)' });
          } else if (type === 'color') {
             setHeroStyle({ backgroundColor: file_path, color: 'white' });
          }
        } else { // Si no hay imagen activa, usar el color por defecto
          setHeroStyle({ backgroundColor: 'rgb(116, 70, 49)', color: 'white' });
        }
      } catch (error) {
        console.error('Error loading data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div className="loading">Cargando marcas...</div>;

  return (
    <div className="marcas-page" style={{ color: 'rgb(116, 70, 49)' }}>
      <div className="container">
        <section className="hero-section" style={{ ...heroStyle, padding: '3rem 0', marginBottom: '3rem', textAlign: 'center' }}>
          <h1 style={{ marginBottom: '0.5rem' }}>Nuestras Marcas</h1>
          <p style={{ fontSize: '1.25rem', opacity: 0.9 }}>
            Trabajamos con las mejores marcas del mercado para garantizar la calidad de nuestros repuestos.
          </p>
        </section>
        
        <div className="brands-grid">
          {brands.map((brand) => (
            <div 
              key={brand.id} 
              className="brand-card"
              onClick={() => navigate(`/marcas/${brand.id}`)}
            >
              <div className="brand-logo-wrapper">
                {brand.logo_path ? (
                  <img
                    src={brand.logo_path}
                    alt={brand.name}
                    className="brand-logo"
                  />
                ) : (
                  <div className="no-logo">Sin Logo</div>
                )}
              </div>
              <h3>{brand.name}</h3>
              {brand.description && <p className="brand-description">{brand.description}</p>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Marcas;